module.exports = __webpack_public_path__ + "img/49.c48bf9c8.jpg";